export const SIGNUP_START = 'SIGNUP_START';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';

export const SET_SIGNUP_REDIRECT_PATH = 'SETP_SIGNUP_REDIRECT_PATH';

export const SET_SALES_REPRESENTATIVES = 'SET_SALES_REPRESENTATIVES';
export const SET_PARTNERS = 'SET_PARTNERS';